module.exports = __webpack_public_path__ + "img/92.ffc555aa.jpg";